<ng-container>
  <fs-axon-livestream-iframe
    [device]="device"
    [actions]="actions"
    [isDocked]="true"
    (closeCamera)="closeCamera()"
  ></fs-axon-livestream-iframe>
</ng-container>
